import { EventType, RecordModel } from './../../../record-model';
import { Section } from './../../../../models/module-structure';
import { LayoutService } from 'src/app/layout/layout.service';
import { RecordLine } from 'src/app/layout/record-model';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import * as g from 'src/app/globals';

@Component({
  selector: 'app-line-section-actions',
  templateUrl: './line-section-actions.component.html',
  styleUrls: ['./line-section-actions.component.less'],
})
export class LineSectionActionsComponent implements OnInit {
  @Input() recordModel: RecordModel;
  @Input() data: any;
  @Input() lines: RecordLine[];
  @Input() section: Section;
  @Output() deleteRow: EventEmitter<number> = new EventEmitter();
  @Output() moveRowUp: EventEmitter<any> = new EventEmitter();
  @Output() addRow: EventEmitter<any> = new EventEmitter();
  @Output() moveRowDown: EventEmitter<any> = new EventEmitter();
  @Output() AddTextLine = new EventEmitter();
  @Output() AddSubTotal = new EventEmitter();
  @Output() DuplicateLine = new EventEmitter();
  @Output() PredefinedText = new EventEmitter();
  enableMovingLineInUpdateMode = false;
  allowAddNewLinesInMiddle = false;
  allowSpecialLines = false;
  allowLineSorting = false;
  allowAdd = false;

  actions: { icon?: string; text?: string; code?: string; divider: boolean }[] =
    [];

  constructor(
    private modalService: NzModalService,
    private layoutService: LayoutService,
    private notification: NzNotificationService
  ) {}

  ngOnInit(): void {
    this.allowAddNewLinesInMiddle = g.allowAddNewLinesInMiddle;
    this.enableMovingLineInUpdateMode =
      g.enableMovingLineInUpdateMode ||
      this.recordModel.EventType === EventType.Create;
    this.allowSpecialLines =
      this.section.AdditionalInformationParsed.AllowSpecialLines;
    this.allowLineSorting =
      this.section.AdditionalInformationParsed.AllowLineSorting;
    this.allowAdd =
      this.section.AdditionalInformationParsed.AllowAdd &&
      (this.section.AdditionalInformationParsed.AllowAddInEditMode ||
        this.recordModel.EventType === EventType.Create) &&
      this.recordModel.EventType !== EventType.View;

    if (this.recordModel.EventType === 3) {
      return;
    }

    const deleteAction = {
      code: 'delete',
      text: 'Delete',
      divider: false,
      icon: 'fal fa-trash',
    };

    const moveUpAction = {
      code: 'move_up',
      text: 'Move Up',
      divider: false,
      icon: 'fal fa-arrow-to-top',
    };

    const moveDownAction = {
      code: 'move_down',
      text: 'Move Down',
      divider: false,
      icon: 'fal fa-arrow-to-bottom',
    };

    const textLineAboveAction = {
      code: 'text_line_above',
      text: 'Text Line Above',
      divider: false,
      icon: 'fal fa-text',
    };

    const textLineBelowAction = {
      code: 'text_line_below',
      text: 'Text Line Below',
      divider: false,
      icon: 'fal fa-text',
    };

    const subTotalLineBelowAction = {
      code: 'add_subtotal_below',
      text: 'Add Subtotal Below',
      divider: false,
      icon: 'fal fa-sigma',
    };

    const duplicateLineAction = {
      code: 'duplicate_line',
      text: 'Duplicate Line',
      divider: false,
      icon: 'fal fa-copy',
    };
    const PredefinedTextAction = {
      code: 'predefined_text',
      text: 'Predefined Text',
      divider: false,
      icon: 'fal fa-quote-left',
    };

    const AddRowAction = {
      code: 'add_row',
      text: 'Add Row',
      divider: false,
      icon: 'fal fa-plus',
    };
    const divider = {
      divider: false,
    };

    if (
      //this.recordModel.EventType === EventType.Create &&
      this.allowAddNewLinesInMiddle &&
      this.data.LineType !== 'S' &&
      this.data.LineType !== 'T'
    ) {
      this.actions.push(AddRowAction);
    }

    if (this.section.AdditionalInformationParsed.AllowDelete) {
      if (this.actions.length > 0) {
        this.actions.push(divider);
      }

      this.actions.push(deleteAction);
    } else if (
      this.section.AdditionalInformationParsed.AllowDeleteForNewLines &&
      (this.data.IsNew || this.data.LineType)
    ) {
      if (this.actions.length > 0) {
        this.actions.push(divider);
      }

      this.actions.push(deleteAction);
    }

    if (this.allowLineSorting && this.enableMovingLineInUpdateMode) {
      if (this.actions.length > 0) {
        this.actions.push(divider);
      }

      this.actions.push(moveUpAction);
      this.actions.push(moveDownAction);
    }
    if (this.allowSpecialLines) {
      if (this.actions.length > 0) {
        this.actions.push(divider);
      }

      if (this.data.LineType !== 'S') {
        this.actions.push(subTotalLineBelowAction);
      }
      if (this.data.LineType === 'T') {
        this.actions.push(PredefinedTextAction);
      }
    }
    if (this.section.AdditionalInformationParsed.AllowAddTextRow) {
      this.actions.push(textLineAboveAction);
      this.actions.push(textLineBelowAction);
    }

    if (this.data.LineType !== 'S' && this.allowAdd) {
      if (this.actions.length > 0) {
        this.actions.push(divider);
      }
      if (this.section.AdditionalInformationParsed.AllowDuplicate) {
        this.actions.push(duplicateLineAction);
      }
    }

    //console.log(this.actions);
  }

  actionClicked(action: {
    icon?: string;
    text?: string;
    code?: string;
    divider: boolean;
  }) {
    if (action.code === 'delete') {
      this.deleteConfirm();
    } else if (action.code === 'move_up') {
      this.moveRowUp.emit(this.data);
    } else if (action.code === 'add_row') {
      this.addRow.emit(this.data);
    } else if (action.code === 'move_down') {
      this.moveRowDown.emit(this.data);
    } else if (
      action.code === 'text_line_below' ||
      action.code === 'text_line_above'
    ) {
      if (this.recordModel.ObjectTypeValue === '202') {
        this.notification.error(
          this.layoutService.translate('Error'),
          this.layoutService.translate(
            'Special lines are not allowed in this module'
          )
        );
        return;
      }
      this.AddTextLine.emit({ row: this.data, action: action.code });
    } else if (action.code === 'add_subtotal_below') {
      if (this.recordModel.ObjectTypeValue === '202') {
        this.notification.error(
          this.layoutService.translate('Error'),
          this.layoutService.translate(
            'Special lines are not allowed in this module'
          )
        );
        return;
      }
      this.AddSubTotal.emit(this.data);
    } else if (action.code === 'duplicate_line') {
      this.DuplicateLine.emit(this.data);
    } else if (action.code === 'predefined_text') {
      this.PredefinedText.emit(this.data);
    }
  }

  deleteConfirm(): void {
    this.modalService.confirm({
      nzTitle: this.layoutService.translate('Are you sure delete this line?'),
      nzOkText: this.layoutService.translate('Yes'),
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => this.deleteRow.emit(this.data.Id),
      nzCancelText: this.layoutService.translate('No'),
    });
  }
}
